import React, { useState } from 'react';

interface CancelButtonProps {
  onCancel: () => void;
  isLoading?: boolean;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onCancel, isLoading = false }) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleClick = () => {
    if (isConfirming) {
      onCancel();
      setIsConfirming(false);
    } else {
      setIsConfirming(true);
      // Auto reset after 3 seconds
      setTimeout(() => setIsConfirming(false), 3000);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`cancel-button ${isConfirming ? 'confirming' : ''} ${isLoading ? 'loading' : ''}`}
      title={isConfirming ? 'Haz clic nuevamente para confirmar cancelación' : 'Cancelar proceso de mejora'}
    >
      {isLoading ? (
        <>
          <span className="cancel-spinner"></span>
          Cancelando...
        </>
      ) : isConfirming ? (
        <>
          <span className="cancel-icon">⚠️</span>
          ¿Confirmar cancelación?
        </>
      ) : (
        <>
          <span className="cancel-icon">✖</span>
          Cancelar
        </>
      )}
    </button>
  );
};

export default CancelButton;